import { createApp } from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import { router } from './router'
import 'view-ui-plus/dist/styles/viewuiplus.css'

import { store } from './store/store'

/**
 功能：路由前验证跳转
 time: 2025-00-29 11:00:59
 **/
router.beforeEach((to, from, next) => {
    ViewUIPlus.LoadingBar.start();
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    // next();
    if (store.getters.token) {
        if (to.path === '/login') {
            next()
        } else {
            if (store.getters.addRouters.length === 0) {
                store.dispatch('GenerateRoutes', { }).then(() => {
                    next({ ...to, replace: true })
                })
            } else {
                next()
            }
        }
    } else {
        if (to.path === '/login') {
            next()
        } else {
            next('/login')
        }
    }
});

router.afterEach(() => {
    ViewUIPlus.LoadingBar.finish();
});


const app = createApp(App)

if (process.env.NODE_ENV === 'development') { //本地环境
    app.config.globalProperties.$siteApi = "http://www.guolang.com/"; //线下
} else if (process.env.NODE_ENV === 'debug') { //调试环境
    app.config.globalProperties.$siteApi = "http://www.guolang.com/"; //线下
} else if (process.env.NODE_ENV === 'production') { // 线上环境
    app.config.globalProperties.$siteApi = "https://api.ahguolang.com/"; //线上
}
//上传通用
app.config.globalProperties.$uploadApi = app.config.globalProperties.$siteApi+"admin/upload/upload_image";
app.config.globalProperties.$uploadFileApi = app.config.globalProperties.$siteApi+"admin/upload/upload_file";

app.use(store)
    .use(router)
    .use(ViewUIPlus, {
    transfer: true
    })
    .mount('#app')
